import React from 'react';
import './icon-button.scss';

interface IconButtonProps {
  icon: React.ReactElement;
  onClick: () => void;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  active?: boolean;
  ariaLabel: string;
  title?: string;
  disabled?: boolean;
  className?: string;
}

export function IconButton({
  icon,
  onClick,
  size = 'md',
  active = false,
  ariaLabel,
  title,
  disabled = false,
  className = '',
}: IconButtonProps) {
  const classes = [
    'icon-button',
    `icon-button--${size}`,
    active ? 'icon-button--active' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
    >
      {icon}
    </button>
  );
}
